import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 子路由的引入
import SUPPLIER_MANAGE_ROUTE from '@/router/business/supplier-manage/supplier-manage'
import LIFE_CYCLE_ROUTE from '@/router/business/supplier-manage/lify-cycle'
import RATING_MANAGE_ROUTE from '@/router/business/supplier-manage/rating-manage'
import FRAME_AGREEMENT_ROUTE from '@/router/business/supplier-manage/frame-agreement'
import BLACKLIST_ROUTE from '@/router/business/supplier-manage/blacklist'

/**
 * 供应商管理路由
 */
export default {
  path: 'supplier-manage',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '供应商管理',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
    platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 供应商管理
    SUPPLIER_MANAGE_ROUTE,
    // 供应商生命周期
    LIFE_CYCLE_ROUTE,
    // 供应商评级评分管理
    RATING_MANAGE_ROUTE,
    // 框架协议
    FRAME_AGREEMENT_ROUTE,
    // 黑名单管理
    BLACKLIST_ROUTE
  ]
}
